import { IUser } from "../models/usermodel";

export interface AuthState {
    isAuth : boolean;
    user: IUser|null;
}

export class AuthService extends EventTarget {
  #authState: AuthState = {
    isAuth: false,
    user: null
  };
  #initialized: boolean = false;
  #initPromise: Promise<void> = new Promise((resolve) => {
    this.#resolveInitPromise = resolve;
  });
  #resolveInitPromise: (value: void | PromiseLike<void>) => void = () => {};

  get state() {
    return this.#authState;
  }

  setUser = (user: IUser|null) => {
    this.#authState = { isAuth: user !== null, user };

    if (!this.#initialized) {
      this.#initialized = true;
      this.#resolveInitPromise();
    }
    this.dispatchEvent(new Event('authStateChanged'));
  }

  async waitForInit() {
    await this.#initPromise;
  }
}

export const authService = new AuthService();
